/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {__} from "language";
import Content from "./components/Content";
import ContextWrapper from "./components/ContextWrapper";
import {
  decode as decodeEntities,
} from "@novivia/utilities/formats/htmlEntities";
import getApplication from "./getApplication";
import React from "react";
import ReactDOM from "react-dom";

/* globals __resourceQuery:false */
// To be used only with webpack. Give path to the component to render as query
// ie: require("./simple?../js/entry/home")
const components = require(__resourceQuery.substr(1));
const Application = getApplication(components.Application)

// Function to render in the frontend.
export default function render() {
  const decodedAuctionEx = decodeEntities(AuctionEx);

  ReactDOM.render(
    <ContextWrapper __={__}>
      <Application {...decodedAuctionEx}>
        <Content auctionEx={decodedAuctionEx} components={components} />
      </Application>
    </ContextWrapper>,
    document.getElementById("page-body"),
  );
}

render();



// WEBPACK FOOTER //
// ../render/simple.js?/private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/js/entry/lot